import { cx } from '@fable/theme'
import { Icon } from '@fable/legacy'

export const QuoteIcon: React.FC<Icon> = ({ color, customClass = '' }) => (
  <svg
    className={cx(customClass, 'fds-ui--quote-icon fds-ui--icon')}
    width="121"
    height="121"
    viewBox="0 0 121 121"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M54.0785 75.056C54.0785 80.7787 52.2226 85.416 48.5106 88.968C44.7986 92.3227 40.1098 94 34.4441 94C27.6062 94 21.9406 91.7307 17.4471 87.192C13.149 82.6533 11 76.1413 11 67.656C11 58.5787 13.5398 49.6987 18.6193 41.016C23.8943 32.136 31.2205 25.1307 40.5982 20L47.3384 30.36C42.2588 33.912 38.1561 37.8587 35.0302 42.2C32.0997 46.5413 30.146 51.5733 29.1692 57.296C30.9275 56.5067 32.9788 56.112 35.3233 56.112C40.7936 56.112 45.287 57.888 48.8036 61.44C52.3202 64.992 54.0785 69.5307 54.0785 75.056ZM108 75.056C108 80.7787 106.144 85.416 102.432 88.968C98.72 92.3227 94.0312 94 88.3656 94C81.5277 94 75.862 91.7307 71.3686 87.192C67.0705 82.6533 64.9214 76.1413 64.9214 67.656C64.9214 58.5787 67.4612 49.6987 72.5408 41.016C77.8157 32.136 85.142 25.1307 94.5196 20L101.26 30.36C96.1803 33.912 92.0775 37.8587 88.9517 42.2C86.0211 46.5413 84.0675 51.5733 83.0906 57.296C84.8489 56.5067 86.9003 56.112 89.2447 56.112C94.715 56.112 99.2085 57.888 102.725 61.44C106.242 64.992 108 69.5307 108 75.056Z"
      fill={color}
    />
  </svg>
)
